module.exports = __webpack_public_path__ + "img/addChartWhite.205c34cf.svg";